import React from "react";

export default function CopyThickIcon({
	color = "#000",
	width = 16,
	height = 16,
}) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.25 2.88086H12.6905C12.9241 2.88086 13.1482 2.97367 13.3134 3.13888C13.4786 3.30409 13.5714 3.52817 13.5714 3.76181V13.4523C13.5714 13.6859 13.4786 13.91 13.3134 14.0752C13.1482 14.2404 12.9241 14.3332 12.6905 14.3332H3.88095C3.64731 14.3332 3.42324 14.2404 3.25802 14.0752C3.09281 13.91 3 13.6859 3 13.4523V3.76181C3 3.52817 3.09281 3.30409 3.25802 3.13888C3.42324 2.97367 3.64731 2.88086 3.88095 2.88086H4.32143"
				stroke={color}
				strokeWidth="2.20238"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
			<path
				d="M10.4887 2H6.08398V3.7619H10.4887V2Z"
				stroke={color}
				strokeWidth="1.7619"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
		</svg>
	);
}
